import { ApiSet, BaseResponse, useDownloadApi, useShowApi } from 'utils/network/api_hooks'
import { Form, useEffectSkipFirst } from 'utils/hooks'
import { CraifHttpClient } from '../utils/network/axios'

export type SalesSearchForm = {
    year?: number
}

export type SalesData = BaseResponse & {
    data?: {
        date?: string
        fixedPurchasedPrice?: number
        fixedPurchasedCount?: number
        purchasedPrice?: number
        purchasedCount?: number
        interviewedPrice?: number
        interviewedCount?: number
        inProgressPrice?: number
        inProgressCount?: number
        sales?: number
        salesCount?: number
        singleCancerSales?: number
        singleCancerCount?: number
        multiCancerSales?: number
        multiCancerCount?: number
        advancePayment?: number
        nAdvancePayment?: number
    }[]
}
export function useFetchSalesApi(searchForm: Form<SalesSearchForm>): ApiSet<SalesData> & { execute: () => void } {
    const apiPath = 'sales/'
    const api = useShowApi<SalesData>(new CraifHttpClient(), {
        initialResponse: {},
    })

    const execute = (): void => {
        api.execute(apiPath, searchForm.object)
    }

    useEffectSkipFirst(() => {
        execute()
    }, [searchForm.object])

    return { ...api, execute: execute }
}

export function useDownloadSalesApi(searchForm: Form<SalesSearchForm>): ApiSet<BaseResponse> & { execute: () => void } {
    const apiPath = 'sales/export/'
    const api = useDownloadApi<BaseResponse>(new CraifHttpClient(), {
        initialResponse: {},
    })

    const execute = (): void => {
        api.execute(apiPath, `${searchForm.object.year}_sales.xlsx`, searchForm.object)
    }

    return { ...api, execute: execute }
}
